import {Injectable, OnInit} from '@angular/core';
import {
    CanActivate,
    Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    CanActivateChild,
    NavigationExtras,
    CanLoad,
    Route,
    NavigationEnd,
    RoutesRecognized,
    ParamMap
} from '@angular/router';
import {AuthService} from './auth.service';
import {ParamService} from './param.service';
import {filter, pairwise} from 'rxjs/operators';


@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
    constructor(
        private authService: AuthService,
        private router: Router,
        private paramService: ParamService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        // const url = state.url.replace('?.html=', '').replace('.html', '');
        const urlWithoutParams = '';
        const params = '';
        return this.checkLogin(urlWithoutParams, params);
    }

    canActivateChild(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {
        console.log('activate child');

        return this.canActivate(route, state);
    }

    canLoad(route: Route): boolean {
        console.log('can load');

        const url = `/${route.path}`;
        return this.checkLogin(url, '');
    }

    checkLogin(url: string, params: any): boolean {
        if (this.authService.getUserInfo()) {
            return true;
        }
        return false;
    }

}
